export default "__VITE_ASSET__D9bTRahI__"